import { ReactComponent as Partition } from '../images/divider-mtn-bee--vectors.svg'

const PartitionBee = ({sectionAbove, skin}) => {
  return (
    <section className={`partition ${sectionAbove}__partition partition--${skin}`}>
      <div className={`container partition__container`}>
        <Partition />
      </div>
    </section>
   )
}

export default PartitionBee

// import PartitionBee from '../../components/PartitionBee'

// <PartitionBee sectionAbove="" skin="light||dark"/>